// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"O3Lmm"};